// src/pages/AddRarityCard.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { useNavigate } from "react-router-dom";
import { api } from "../components/Api";

export default function AddRarityCard() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        license_card_id: "",
        rarity_name: "",
    });
    const [licenses, setLicenses] = useState([]);
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    // Récupération des licences
    useEffect(() => {
        const fetchLicenses = async () => {
            try {
                const res = await api.get("/license-cards");
                setLicenses(res.data);
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération des licences.");
            }
        };
        fetchLicenses();
    }, []);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { license_card_id, rarity_name } = form;

        // Vérifications simples
        if (!license_card_id) return alert("Veuillez sélectionner une licence.");
        if (!rarity_name.trim()) return alert("Le nom de la rareté est obligatoire.");

        try {
            await api.post("/rarity-cards", { license_card_id, rarity_name });
            alert("Rareté ajoutée avec succès !");
            navigate("/rarity_card-list");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'ajout de la rareté.");
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6 max-w-md">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Ajouter une Rareté</h1>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="license_card_id" className="block font-medium mb-1">Licence :</label>
                    <select
                        id="license_card_id"
                        name="license_card_id"
                        value={form.license_card_id}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    >
                        <option value="">-- Sélectionnez une licence --</option>
                        {licenses.map(l => (
                            <option key={l.id} value={l.id}>{l.license_card}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="rarity_name" className="block font-medium mb-1">Nom de la rareté :</label>
                    <input
                        type="text"
                        id="rarity_name"
                        name="rarity_name"
                        value={form.rarity_name}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    />
                </div>

                <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
                >
                    Ajouter
                </button>
            </form>
        </div>
    );
}
